import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { SubTabs, SubTab } from 'components/layout'
import { meta } from 'helpers/decorators'
import { apiCodeLists } from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import AssessorsAccountRegistration from './AssessorsAccountRegistration'
import AssessorsActivityCategoryRegistration from './AssessorsActivityCategoryRegistration'
import AssessorsBecomeAssessor from './AssessorsBecomeAssessor'
import AssessorsWaitingActivityAuthorization from './AssessorsWaitingActivityAuthorization'


const enhance = compose(
  meta({
    title: 'Assessors - Pending',
    intlKey: 'pageTitle.assessor_pending'
  }),
  connect(null, { modal }),
  apiCodeLists(['activityReviseReasons']),
)

class AssessorPending extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired
  }

  render() {
/*    const {

    } = this.props*/

    return (
      <div>
        <SubTabs onChange={this.handleTabsChange}>
          <SubTab
            title="Account registration"
            intlKey="tabs.account_registration"
          >
            <AssessorsAccountRegistration />
          </SubTab>
          <SubTab
              title="Activity registration"
              intlKey="tabs.activity_registration"
          >
            <AssessorsActivityCategoryRegistration />
          </SubTab>
          <SubTab
              title="Become assessor"
              intlKey="tabs.become_assessor"
          >
            <AssessorsBecomeAssessor />
          </SubTab>
          <SubTab
              title="Sign-off requests"
              intlKey="tabs.signoff_requests"
          >
            <AssessorsWaitingActivityAuthorization />
          </SubTab>
        </SubTabs>
      </div>
    )
  }
}

export default enhance(AssessorPending)
